(function () {
  function collectionHandle() {
    const match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  // latest-arrivals uses Shopify's manual collection order (same as the homepage
  // Latest Arrivals section). Do not re-sort that grid by PO received date.
  const latestArrivalParam = new URLSearchParams(window.location.search).get('ovs_mk_latest_arrival') || '';
  if (
    !collectionHandle() ||
    collectionHandle() === 'pre-orders' ||
    collectionHandle() === 'latest-arrivals' ||
    latestArrivalParam.split(',').includes('y')
  ) {
    return;
  }

  function arrivalKey(item) {
    return (item.getAttribute('data-ovs-arrived-at') || '').trim();
  }

  function compareArrivalDesc(left, right) {
    const keyA = arrivalKey(left);
    const keyB = arrivalKey(right);
    if (keyA === keyB) {
      return 0;
    }
    if (keyA === '') {
      return 1;
    }
    if (keyB === '') {
      return -1;
    }

    return keyB.localeCompare(keyA);
  }

  function cancelScrollAnimations(grid) {
    grid.classList.add('scroll-trigger--cancel');
    grid.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
      element.classList.remove('scroll-trigger--offscreen');
      element.style.removeProperty('--animation-order');
    });
  }

  function sortGridByArrivalDesc() {
    if (window.OVS_MK_FILTERED_MODE || /[?&]ovs_mk_/.test(window.location.search)) {
      return;
    }

    const grid = document.getElementById('product-grid');
    if (!grid) {
      return;
    }

    const items = [...grid.querySelectorAll(':scope > .grid__item')];
    if (items.length < 2) {
      return;
    }

    cancelScrollAnimations(grid);

    items.sort(compareArrivalDesc);

    const fragment = document.createDocumentFragment();
    items.forEach((item) => {
      fragment.appendChild(item);
    });
    grid.appendChild(fragment);
  }

  window.ovsCompareArrivalDesc = compareArrivalDesc;
  window.ovsSortCollectionByArrivalDate = sortGridByArrivalDesc;

  document.addEventListener('DOMContentLoaded', () => {
    window.requestAnimationFrame(sortGridByArrivalDesc);
  });

  document.addEventListener(
    'change',
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) {
        return;
      }

      if (target.closest('.ovs-mk-filters')) {
        return;
      }

      if (target.closest('#main-collection-filters, .mobile-facets, .facets-wrapper')) {
        window.requestAnimationFrame(sortGridByArrivalDesc);
      }
    },
    true,
  );

  window.addEventListener('popstate', () => {
    window.requestAnimationFrame(sortGridByArrivalDesc);
  });
})();
